import React, {useState} from 'react'
import {Button, Dimmer, Form, Header, Icon, Loader, Message} from "semantic-ui-react";

import SimpleReactValidator from 'simple-react-validator';

const EmailResend = (props) => {
    const getTerm = props.getTerm;

    const [errorString, setError] = useState();
    const [emailAddress, setEmailAddress] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const validator = new SimpleReactValidator();

    const submitForm = (e) =>
    {
        setError();
        setEmailError();
        setFirstNameError();
        setLastNameError();

        let hasErrors = false;

        if (!validator.check(emailAddress, 'required|email'))
        {
            setEmailError(true);
            hasErrors = true;
        }

        if (!hasErrors)
        {
            setLoading(true);
            props.dataManager.resendEmail(emailAddress, firstName, lastName)
                .then(response => {
                    setLoading(false);
                    console.log(response);
                    if (typeof response.data.success !== "undefined") {
                        if (response.data.success == 0) {
                            setError(response.data.errorMessage);
                        } else {
                            setSuccess(true);
                        }
                    }
                    else
                    {
                        setError(response.data);
                        setLoading(false);
                    }
                });
        }
        else
        {
            setError(getTerm("c893573c-d13d-11f0-8346-0ac9221eb135", "Please review the fields marked below."));
        }
    }


    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>{getTerm("bda913ca-d13d-11f0-8346-0ac9221eb135", "Loading")}</Loader>
            </Dimmer>

            <Header as='h2' style={{marginTop: 0}}>{getTerm("c52d8bbc-d142-11f0-8346-0ac9221eb135", "Email Validation Re-Send Request")}</Header>
            <div>
                <p>{getTerm("02689666-d143-11f0-8346-0ac9221eb135", "If you have not yet received a validation email, please complete the form below to have it resent. You must use the exact same information provided during registration.")}</p>
                <p>{getTerm("4a6e1f58-d143-11f0-8346-0ac9221eb135", "Please note that some email software automatically moves email messages into a \"Spam\" or \"Junk email\" folder. Please check to see if the Validation email got placed in one of those folders. If so, please right-click on the message to add the sender to your \"Safe Senders List\". If your email provider provides a \"whitelist\" function, please add the following email Address to the list: &#110;&#111;&#116;&#105;&#102;&#105;&#099;&#097;&#116;&#105;&#111;&#110;&#115;&#064;&#105;&#097;&#116;&#102;&#097;&#100;&#112;&#046;&#099;&#111;&#109;")}</p>
            </div>

            { (typeof errorString !== "undefined") &&
            <Message error icon>
                <Icon name='exclamation' />
                <Message.Content>
                    <Message.Header>{getTerm("c2d4a314-d13d-11f0-8346-0ac9221eb135", "An error occurred")}</Message.Header>
                    {errorString}
                </Message.Content>
            </Message>
            }

            { (success) &&
            <Message success icon>
                <Icon name='check' />
                <Message.Content>
                    <Message.Header>{getTerm("2c695cba-d144-11f0-8346-0ac9221eb135", "Email Sent")}</Message.Header>
                    {getTerm("35d76d50-d144-11f0-8346-0ac9221eb135", "It may take 15 to 30 minutes for the email to show up in your inbox.")}
                </Message.Content>
            </Message>
            }

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>
                <Form.Group widths='equal'>
                    <Form.Field required label={getTerm("9dfaa8f6-d465-11f0-9cd9-0ac9221eb135", "Surname (Last/Family Name):")} control="input" value={lastName} onChange={(e) => setLastName(e.target.value)} error={lastNameError} />
                    <Form.Field required label={getTerm("ca7ce614-d465-11f0-9cd9-0ac9221eb135", "Given Names:")} control="input" value={firstName} onChange={(e) => setFirstName(e.target.value)} error={firstNameError} />
                </Form.Group>
                <Form.Field required label={getTerm("029d7c1a-d12e-11f0-8346-0ac9221eb135", "Email Address")} control="Input" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} placeholder="user@domain.com" error={emailError} />
                <Button type='submit'>{getTerm("f6266058-d143-11f0-8346-0ac9221eb135", "Request Re-send")}</Button>
            </Form>
            <br /><p><a href="#" onClick={(e) => { props.setStep("validate");}}>{getTerm("0bbda570-d144-11f0-8346-0ac9221eb135", "Return to Validation Page")}</a></p>
        </div>
    )
}

export default EmailResend;